import React from 'react';

type BBox = { minLat: number; minLon: number; maxLat: number; maxLon: number; name?: string };
type Circle = { lat: number; lon: number; radiusKm: number; name?: string };

export default function GeoReadOnly({ bboxes, circles }: { bboxes: BBox[]; circles: Circle[] }) {
  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <div>
        <h4 style={{ margin: '4px 0' }}>Bounding Boxes</h4>
        <table className="tbl">
          <thead><tr><th>Name</th><th>minLat</th><th>minLon</th><th>maxLat</th><th>maxLon</th></tr></thead>
          <tbody>
            {(!bboxes || bboxes.length === 0) && <tr><td colSpan={5}><span className="muted">None</span></td></tr>}
            {(bboxes || []).map((b: any, i: number) => (
              <tr key={i}><td>{b.name || '-'}</td><td>{b.minLat}</td><td>{b.minLon}</td><td>{b.maxLat}</td><td>{b.maxLon}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
      <div>
        <h4 style={{ margin: '4px 0' }}>Circles</h4>
        <table className="tbl">
          <thead><tr><th>Name</th><th>lat</th><th>lon</th><th>radiusKm</th></tr></thead>
          <tbody>
            {(!circles || circles.length === 0) && <tr><td colSpan={4}><span className="muted">None</span></td></tr>}
            {(circles || []).map((c: any, i: number) => (
              <tr key={i}><td>{c.name || '-'}</td><td>{c.lat}</td><td>{c.lon}</td><td>{c.radiusKm}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

